import * as angular from 'angular';
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.lean-planning')
  .factory('LeanPlanningAPI', LeanPlanningAPI);

function LeanPlanningAPI(): BringozApi {
  return {
    base: `/leanPlanning`,
    infiniteScroll: {
      address: `/leanPlanning`,
      cmd: 'GET'
    },
    actions: {
      createRoute: {
        address: 'routes',
        cmd: 'PUT',
        updateable: false
      },
      createRouteNew: {
        address: 'routes/new',
        cmd: 'PUT',
        updateable: true
      },
      getPlans: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      updatePlan: {
        address: '',
        cmd: 'POST',
        updateable: false
      },
      getSuggestedDeliveries : {
        address : 'routes/{routeId}/actions/deliveries',
        cmd : 'GET',
        updateable: true
      },
      putDelivery : {
        address : 'routes/{routeId}/actions/deliveries',
        cmd : 'PUT',
        updateable: true
      },
      removeDelivery : {
        address : 'routes/{routeId}/actions/deliveries',
        cmd : 'DELETE',
        updateable: true
      }
    }
  }
}
